export const POWER_UP_CONFIG = {
    baseScale: 0.25,

    orbScale: 1.8,
    orbYOffset: -0.4,

    idleRotationSpeed: 1.2,
    idleBobAmplitude: 0.12,
    idleBobSpeed: 1.8,
    idleTrackRotationOffset: 0.7,

    collectDuration: 0.4,
    collectScalePeak: 2.0,
    collectRotationTurns: 2,

    glowPlaneYOffset: 1.0,
    glowPlaneSize: 1.3,
    glowPlaneOpacity: 0.475,

    particleCount: 50,
    particleSize: 0.1,
    particleOpacity: 0.55,
    particleSpeed: 2.0,
    particleSpread: 0.75,
    particleLifetime: 1.0,
    particleUpwardBias: 0,
    particleDrag: 1,

    shadowOpacity: 0.6,
} as const
